import { useTranslation } from "react-i18next"

import { ChevronDown, ChevronUp } from "@/components/icons"
import { CollapsibleTrigger } from "@/components/ui/collapsible"
import { Label } from "@/components/ui/label"

interface CollapsibleToolsHeaderProps {
  isExpanded: boolean
  toolCount: number
}

export function CollapsibleToolsHeader({ isExpanded, toolCount }: CollapsibleToolsHeaderProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "workflowLanding.agentNode" })

  return (
    <CollapsibleTrigger asChild>
      <button
        className="nodrag hover:bg-muted/50 focus-visible:ring-ring flex w-full items-center justify-between rounded px-1 py-0.5 text-left focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
        type="button"
      >
        <Label className="pointer-events-none text-xs">{t("enabledTools")}</Label>
        <div className="flex items-center gap-1">
          <span className="text-muted-foreground text-[10px]">
            {t("toolsEnabled", { count: toolCount })}
          </span>
          {isExpanded ? (
            <ChevronUp className="text-muted-foreground size-3" />
          ) : (
            <ChevronDown className="text-muted-foreground size-3" />
          )}
        </div>
      </button>
    </CollapsibleTrigger>
  )
}
